module.exports = __webpack_public_path__ + "img/icon_setup_eye_select@2x.1e234351.png";